"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-sostene": {
    "69b82f37": [{
      "hkey": "97bf555c",
      "slug": "san-sostene",
      "name": "San Sostene",
      "primary": true,
      "skipSearch": false
    }],
    "casolariti": [{
      "hkey": "97bf555c",
      "slug": "san-sostene",
      "name": "San Sostene",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5bc43d66": [{
      "hkey": "97bf555c",
      "slug": "san-sostene",
      "name": "San Sostene",
      "primary": true,
      "skipSearch": false
    }],
    "marina": [{
      "hkey": "97bf555c",
      "slug": "san-sostene",
      "name": "San Sostene",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;